import { render } from "./AboutCompanyComponent.vue?vue&type=template&id=1a1a474b"
import script from "./AboutCompanyComponent.vue?vue&type=script&lang=js"
export * from "./AboutCompanyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__